import { useQuery } from 'react-query';
import { IGetAttachment } from 'app/models/common/request';
import { getProfileImageByUserId } from 'app/components/helpers';
import { useGetAttachments as sdsgUseGetAttachments } from './sdsg-api';
import { useGetAttachments as cxpUseGetAttachments } from './cxp-api';
import { useGetAttachments as cssUseGetAttachments } from './css-api';
import { useGetAttachments as crewUseGetAttachments } from './crew-api';
import { useGetUsersList as userUseGetUsersList } from './user-api';
import { useGetUsersList as requestUseGetUsersList } from './request-api';

/**
 *
 * @returns Deals with character data api
 * Call this method from anywhere
 * Caching handled by react query
 * TODO: Enforce strong typing
 */

/**
 * Module: Request Assignment/Comments People Picker
 * Custom hook to get list of users */
export const useGetUsersList = (
    searchValue: string,
    isDomainSpecific: boolean,
    type: 'Admin' | null = null,
    team?: number,
    count?: number
) => {
    if(!isDomainSpecific) {
        return userUseGetUsersList(searchValue,type,null,null);
    } else if (type === "Admin") {
        return userUseGetUsersList(searchValue,type,team,count);
    }
    return requestUseGetUsersList(searchValue,team,count);
};

export const useGetAttachments = (requestData: IGetAttachment) => {
    switch (requestData.team) {
        case 1: // SDSG
            return sdsgUseGetAttachments(requestData);
        case 2: // CXP
            return cxpUseGetAttachments(requestData);
        case 3: // CSS
            return cssUseGetAttachments(requestData);
        case 4: // Crew
            return crewUseGetAttachments(requestData);
        default:
            break;
    }
}

// Not using 7001 - uses graph.microsoft.com
// get user profile pictures from Graph
// set cache time to 2 hours (milliseconds), any profile pictures that have not been rendered in that time are dumped
export const useGetUserProfilePicture = (userId: string) => {
    return useQuery(
        userId,
        async () => {
            return await getProfileImageByUserId(userId);
        },
        { staleTime: Infinity, cacheTime: 7200000 }
    );
};